import { Link } from "react-router-dom";
import { MessageCircle, Instagram, Mail } from "lucide-react";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

interface ContactInfo {
  whatsapp: string;
  instagram: string;
  email: string;
}

export function Footer() {
  const [contact, setContact] = useState<ContactInfo>({
    whatsapp: "",
    instagram: "",
    email: "",
  });

  useEffect(() => {
    const fetchContact = async () => {
      const { data } = await supabase
        .from("site_settings")
        .select("key, value")
        .in("key", ["contact_whatsapp", "contact_instagram", "contact_email"]);

      if (data) {
        const info: ContactInfo = { whatsapp: "", instagram: "", email: "" };
        data.forEach((item) => {
          if (item.key === "contact_whatsapp") info.whatsapp = String(item.value || "");
          if (item.key === "contact_instagram") info.instagram = String(item.value || "");
          if (item.key === "contact_email") info.email = String(item.value || "");
        });
        setContact(info);
      }
    };
    fetchContact();
  }, []);

  return (
    <footer className="border-t border-border bg-card">
      <div className="container py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-2">
              <div className="flex h-9 w-9 items-center justify-center rounded-xl gradient-primary">
                <span className="text-lg font-bold text-primary-foreground">D</span>
              </div>
              <div className="flex flex-col">
                <span className="text-lg font-bold text-foreground">​Uangcuan.ID  </span>
                <span className="text-xs text-primary font-medium">​Semua ada disini</span>
              </div>
            </Link>
            <p className="text-sm text-muted-foreground">
              Toko digital terpercaya untuk akun premium streaming dan aplikasi populer dengan harga terjangkau.
            </p>
          </div>

          <div className="space-y-4">
            <h4 className="font-semibold text-foreground">Navigasi</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-muted-foreground hover:text-primary transition-colors">Home</Link>
              <Link to="/products" className="text-sm text-muted-foreground hover:text-primary transition-colors">Produk</Link>
              <Link to="/faq" className="text-sm text-muted-foreground hover:text-primary transition-colors">FAQ</Link>
              <Link to="/garansi" className="text-sm text-muted-foreground hover:text-primary transition-colors">Garansi</Link>
            </div>
          </div>

          <div className="space-y-4">
            <h4 className="font-semibold text-foreground">Produk Populer</h4>
            <div className="flex flex-col gap-2">
              <span className="text-sm text-muted-foreground">Netflix Premium</span>
              <span className="text-sm text-muted-foreground">Spotify Premium</span>
              <span className="text-sm text-muted-foreground">YouTube Premium</span>
              <span className="text-sm text-muted-foreground">ChatGPT Plus</span>
            </div>
          </div>

          <div className="space-y-4">
            <h4 className="font-semibold text-foreground">Hubungi Kami</h4>
            <div className="flex flex-col gap-3">
              {contact.whatsapp && (
                <a 
                  href={`https://wa.me/${contact.whatsapp}`} 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  <MessageCircle className="h-4 w-4" />
                  WhatsApp
                </a>
              )}
              {contact.instagram && (
                <a 
                  href={`https://instagram.com/${contact.instagram}`}
                  target="_blank"
                  rel="noopener noreferrer" 
                  className="flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  <Instagram className="h-4 w-4" />
                  @{contact.instagram}
                </a>
              )}
              {contact.email && (
                <a 
                  href={`mailto:${contact.email}`} 
                  className="flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  <Mail className="h-4 w-4" />
                  {contact.email}
                </a>
              )}
            </div>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground">
            © 2025 UangCuanID. All rights reserved.
          </p>
          <div className="flex gap-4 text-sm text-muted-foreground">
            <Link to="/terms" className="hover:text-primary transition-colors">Syarat & Ketentuan</Link>
            <Link to="/privacy" className="hover:text-primary transition-colors">Kebijakan Privasi</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}